import React from 'react';
import {useParams} from 'react-router-dom';

import {ErrorBoundary} from '@sentry/react';
import {ErrorPage} from 'src/modules/error-page/error-page.components';

import Loading from '@pb/kit-component-loading';

import {REPORTS_SUB_TABS} from '../../constants';
import {ReportsTabs} from '../../report-tabs';

import {UsageReportSettings} from './usage-report-settings';

export const UsageReportV2 = () => {
    const queryParams = useParams<{accountId: string, licenseId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : null;
    const licenseId = queryParams.licenseId ? +queryParams.licenseId : null;

    if (!accountId || !licenseId) {
        return <Loading fast={true}/>;
    }

    return (
        <ErrorBoundary fallback={<ErrorPage subtitle="Please try again later." title="Something went wrong."/>}>
            <ReportsTabs accountId={accountId} licenseId={licenseId} activeSubTab={REPORTS_SUB_TABS.USAGE_REPORT.name}/>
            <UsageReportSettings accountId={accountId}/>
        </ErrorBoundary>
    );
};
